(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  function initHoverMenus() {
    document.querySelectorAll('.header__inline-menu header-menu > details').forEach((details) => {
      if (details.dataset.cpcHoverMenu === 'true') return;

      const host = details.closest('header-menu');
      if (!host) return;

      let closeTimer;

      const openMenu = () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 380);
      };

      host.addEventListener('mouseenter', openMenu);
      host.addEventListener('mouseleave', closeMenu);
      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
      details.querySelectorAll('.mega-menu__content, .header__submenu').forEach((panel) => {
        panel.addEventListener('mouseenter', openMenu);
        panel.addEventListener('mouseleave', closeMenu);
      });
      host.addEventListener('focusin', openMenu);
      host.addEventListener('focusout', (event) => {
        if (!host.contains(event.relatedTarget)) closeMenu();
      });

      details.dataset.cpcHoverMenu = 'true';
    });
  }

  function initContactScroll() {
    document.querySelectorAll('[data-cpc-scroll-to]').forEach((trigger) => {
      if (trigger.dataset.cpcScrollReady === 'true') return;

      trigger.addEventListener('click', (event) => {
        const target = document.getElementById(trigger.dataset.cpcScrollTo);
        if (!target) return;

        event.preventDefault();
        const panel = target.closest('.cpc-contact__form-panel') || target;
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        panel.classList.add('cpc-contact__form-panel--focus');
        window.setTimeout(() => panel.classList.remove('cpc-contact__form-panel--focus'), 900);
        window.setTimeout(() => target.querySelector('input, select, textarea')?.focus({ preventScroll: true }), 650);
      });

      trigger.dataset.cpcScrollReady = 'true';
    });
  }

  function initContactSubjectField() {
    const topic = document.getElementById('ContactForm-topic');
    const input = document.querySelector('[data-cpc-dynamic-subject]');
    const label = document.querySelector('[data-cpc-dynamic-subject-label]');

    if (!topic || !input || !label || topic.dataset.cpcSubjectReady === 'true') return;

    const updateLabel = () => {
      const subjectTypes = ['Customer service', 'Warranty or product issue', 'Other'];
      const isSubject = subjectTypes.includes(topic.value);
      label.textContent = isSubject ? 'Subject' : 'Budget and use case';
      input.placeholder = isSubject
        ? 'Subject, order number, or issue'
        : 'Budget and use case';
      input.setAttribute(
        'aria-label',
        isSubject ? 'Subject, order number, or issue' : 'Budget and use case'
      );
    };

    topic.addEventListener('change', updateLabel);
    updateLabel();
    topic.dataset.cpcSubjectReady = 'true';
  }

  function initReviewCarousel() {
    document.querySelectorAll('[data-cpc-review-track]').forEach((track) => {
      if (track.dataset.cpcReviewReady === 'true') return;

      const section = track.closest('.cpc-trustpilot');
      if (!section) return;

      const scrollAmount = () => Math.max(320, track.clientWidth * 0.8);

      section.querySelectorAll('[data-cpc-review-prev]').forEach((button) => {
        button.addEventListener('click', () => {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      });

      section.querySelectorAll('[data-cpc-review-next]').forEach((button) => {
        button.addEventListener('click', () => {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      });

      track.dataset.cpcReviewReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initHoverMenus();
      initContactScroll();
      initContactSubjectField();
      initReviewCarousel();
    });
  } else {
    initHoverMenus();
    initContactScroll();
    initContactSubjectField();
    initReviewCarousel();
  }
})();
